import {getIsSdkPage} from '@/kuSdk/view/DocViewAll/utils/isSdkPage';
import {pluginFactory} from './factory';
import {FlexBuilderType} from './constant';
import {EntryTooltipContentFactory} from './render/EntryTooltipContent';
import {getConfigs} from '@/kuSdk/view/DocViewAll/utils/configs';
import {IExtensionInstance} from '@baidu/realtime-editor';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';

const {isInGrayPromise: isMatchBackendFlexBuilder} = initGray(
    GRAY_RELEASE_KEYS.backendFlexBuilder
);

export default pluginFactory({
    viewNode: {
        title: '后端随心搭',
        getQuote: () => {
            return '后端随心搭';
        },
    },
    insert: {
        title: '后端随心搭 Beta',
        keywords: ['hdsxd', '后端随心搭', 'houduansuixinda'],
        tip: EntryTooltipContentFactory({
            title: '后端随心搭 Beta',
            flexBuilderType: FlexBuilderType.backend,
        }),
        hook: (config: IExtensionInstance['insert'], utils: any) => {
            let hasTrigUpdate = false;
            isMatchBackendFlexBuilder().then((inGray) => {
                if (inGray && !hasTrigUpdate) {
                    hasTrigUpdate = true;
                    utils?.update?.(config);
                }
            });
        },
        toolbar: {
            enable: () => {
                if (getIsSdkPage()) {
                    return !!getConfigs().backendFlexBuilder;
                }
                return true;
            },
        },
    },
    flexBuilderType: FlexBuilderType.backend,
});
